import React, { Component } from 'react';
import Close from '@mui/icons-material/Close';
import withStyles from '@mui/styles/withStyles';
import { Dialog, DialogActions, DialogContent, FormControl, Grid, IconButton, TextField, Typography } from '@mui/material';

import { disableAttributeCheck, getValueForRender } from '../../utils/InputUtils';
import SaveButton from '../ui/SaveButton';
import AbEnvironment from '../auth/AbEnvironment';
import FormCreateMutation from './FormCreateMutation';

const abEnvironment = new AbEnvironment();

const styleSheet = theme => {

};

class FormCreateDialog extends Component {

  constructor(props) {
    super(props);
    this.state = {
      createFormDescription: null,
      createFormName: null,
      createFormTitle: null,
      createFormSubtitle: null,
    };
  }

  handleClose = (event) => {
      this.props.onClose(event);
  };

  /**
   * if all the required fields are changed, enable; otherwise, disable.
   * @returns Boolean
   */
  disableFormCreateSave() {
    let retval = (disableAttributeCheck(this.state.createFormName, null)
                  || disableAttributeCheck(this.state.createFormTitle, null)
                  || disableAttributeCheck(this.state.createFormDescription, null));

    return retval;
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
    if (this.props.onChange) {
      this.props.onChange();
    }
  }

  render() {
    
    
    return (
      <Dialog
        maxWidth={false}
        open={this.props.open}>
        <Typography>
          <IconButton size="small"
            style={{ float: 'right', margin: '5px' }}
            onClick={() => {
              this.setState({ createFormName: null, createFormTitle: null, createFormSubtitle: null, createFormDescription: null});
              this.props.onClose();
            }}
          ><Close /></IconButton>
        </Typography>
        <DialogContent>
          <Grid container>
            <Grid item xs={12}>
              <Typography variant='h4'>Describe and title the form</Typography>
            </Grid>
            <Grid item xs={12}>
              <FormControl>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      error={!this.state.createFormName && this.props.formSaveStatus && this.props.formSaveStatus === 'error'}
                      id="form-name" label="Form name"
                      name='createFormName'
                      value={ getValueForRender(this.state.createFormName, null, '') }
                      onChange={ (e) => this.handleChange(e)}
                      inputProps={{ maxLength: 64 }}
                      />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField 
                      required
                      error={!this.state.createFormTitle && this.props.formSaveStatus && this.props.formSaveStatus === 'error'}
                      id="form-title" label="Form title"
                      name='createFormTitle'
                      value={ getValueForRender(this.state.createFormTitle, null, '') }
                      onChange={ (e) => this.handleChange(e)}
                      inputProps={{ maxLength: 128 }}
                      />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField 
                      required
                      error={!this.state.createFormDescription && this.props.formSaveStatus && this.props.formSaveStatus === 'error'}
                      id="form-description" label="Form description"
                      name='createFormDescription'
                      value={ getValueForRender(this.state.createFormDescription, null, '') }
                      onChange={ (e) => this.handleChange(e)}
                      inputProps={{ maxLength: 1024 }}
                      />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField 
                      id="form-subtitle" label="Form subtitle"
                      name='createFormSubtitle'
                      value={ getValueForRender(this.state.createFormSubtitle, null, '') }
                      onChange={ (e) => this.handleChange(e)}
                      inputProps={{ maxLength: 1024 }}
                    />
                  </Grid>
                </Grid>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <SaveButton
            onSaveClick={() => { this._createForm(); }}
            onSnackbarClose={() => { this.props.hideSnackbar(); }}
            disabled={this.disableFormCreateSave(this.props)}/>
        </DialogActions>
      </Dialog>
    );
  }

  createFormInputValidate() {
    if (!this.state.createFormName || !this.state.createFormTitle || !this.state.createFormDescription) {
      //required fields not filled in, set the "form snackbar" stuff..
      this.props.showSnackbar('error', 'Missing required fields for the form.', 5000);
      return false;
    }

    return true;
  }

  _createForm() {
    //clear the previous state variables for "snackbar and status stuff"
    if (this.props.hideSnackbar) 
      this.props.hideSnackbar();

    if (!this.createFormInputValidate()) {
      return;
    }

    const accountId = abEnvironment.getUserAttribute('a_id');
    const { createFormName, createFormTitle, createFormDescription, createFormSubtitle } = this.state;

    //set state saving, then commit action...
    this.setState({
      formSaveStatus: 'saving'
    });
    return FormCreateMutation.commit(accountId, createFormName, createFormTitle, createFormSubtitle, createFormDescription)
    .then((response) => {
      //... and mention "success"
      this.props.showSnackbar('success', 'Form \'' + createFormName + '\' successfully created.', 3000);
      this.handleClose();
      if (this.props.onSaveSuccess) {
        let formId = response.createFormT.formT.formId;
        this.props.onSaveSuccess(formId);
      }
    })
    .catch((error) => {
      console.log(error);
      this.props.showSnackbar('error', 'Unable to create form \'' + createFormName + '\'.', 5000);
    });
  }
}
  
export default withStyles(styleSheet)(FormCreateDialog);